module.exports = __webpack_public_path__ + "static/img/Lark20220424-133047.1f84c1cc.png";